<template>
  <v-layout wrap justify-center>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="blue"
      spinner="mini-spinner"
    />
    <v-snackbar
      :timeout="3000"
      :value="true"
      right
      color="red"
      v-model="showsnackbar"
    >
      <span style="font-size: 20px"> {{ msg }}</span>
    </v-snackbar>
    <v-flex xs12 lg11 pt-6>
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-card
            class="mx-auto elevation-1 pa-6"
            max-width="1088px"
            align="center"
            outlined
          >
            <v-layout wrap justify-space-between>
              <v-flex
                xs12
                sm6
                pb-2
                pb-md-0
                class="text-left nsbold"
                style="font-weight: 700; font-size: 20px"
                >Map Student
              </v-flex>
              <!-- <v-flex
                xs12
                sm3
                md4
                lg4
                pb-2
                pb-md-0
                align-self-center
                class="text-left nsregular"
              >
                <v-text-field
                  v-model="keyword"
                  dense
                  class="rounded-xl"
                  label="Search"
                  outlined
                  hide-details
                  clearable
                ></v-text-field>
              </v-flex> -->
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 align-self-center>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap justify-center pa-4>
                    <v-flex xs12 sm6 align-self-center pa-2>
                      <v-text-field
                        dense
                        hide-details
                        outlined
                        required
                        label="Bus Stop Name"
                        v-model="mapData.name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 align-self-center pa-2>
                      <v-text-field
                        dense
                        hide-details
                        outlined
                        required
                        label="Latitude"
                        v-model="mapData.lat"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 align-self-center pa-2>
                      <v-text-field
                        dense
                        hide-details
                        outlined
                        required
                        label="Longitude"
                        v-model="mapData.lon"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 align-self-center pa-2>
                      <v-select
                        dense
                        hide-details
                        outlined
                        required
                        :item-text="
                          (item) => item.name + ' - ' + item.routeId.name
                        "
                        item-value="_id"
                        :items="tripList"
                        label="Choose Trip"
                        v-model="mapData.tripId"
                        @input="getMapped(mapData.tripId)"
                      ></v-select>
                    </v-flex>

                    <v-flex
                      xs12
                      sm6
                      align-self-center
                      pa-2
                      v-if="mapData.tripId"
                    >
                      <v-select
                        dense
                        hide-details
                        outlined
                        required
                        :item-text="(item) => item.placeId.name"
                        item-value="placeId._id"
                        :items="placeList"
                        label="Choose Place"
                        v-model="mapData.placeId"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 align-self-center pa-2>
                      <v-select
                        :items="classList"
                        v-model="cls"
                        label="Class"
                        item-text="standardName"
                        item-value="_id"
                        clearable
                        hide-details
                        outlined
                        dense
                      ></v-select>
                    </v-flex>
                    <!-- <v-flex xs12 sm6 align-self-center pa-2 v-if="cls">
                      <v-select
                        :items="divisionList"
                        v-model="division"
                        clearable
                        hide-details
                        label="Division"
                        item-text="divisionName"
                        item-value="_id"
                        outlined
                        dense
                      ></v-select>
                    </v-flex> -->

                    <v-flex xs12 sm6 align-self-center pa-2>
                      <v-autocomplete
                        v-model="mapData.studentId"
                        :items="students"
                        item-text="title"
                        :search-input.sync="searchInput"
                        item-value="_id"
                        outlined
                        label="Choose Student/Admn. No."
                        placeholder="Search Student/Admn. No."
                        dense
                        hide-details
                      >
                      </v-autocomplete>
                    </v-flex>
                    <!-- <v-flex xs1 align-self-center> 
                      <v-icon
                        @click="(mapData.studentId = null), getStudents()"
                        title="Refresh Student list"
                        >mdi-refresh</v-icon
                      > 
                    </v-flex> -->

                    <v-flex xs12>
                      <v-spacer></v-spacer>
                    </v-flex>
                    <v-flex xs12 sm4 md3 pa-2 align-self-center text-center>
                      <v-btn
                        :disabled="!valid"
                        color="#766BC0"
                        class="body-2 font-weight-bold"
                        block
                        dark
                        @click="validateInput()"
                        >Submit</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog width="450px" v-model="dialoge">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Confirm Delete </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4 black--text"
            >Are you sure you want to delete this record?
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="dialoge = false"
              >Cancel</v-btn
            >
            <v-btn
              color="#766BC0"
              class="body-2 font-weight-bold"
              outlined
              @click="deleteTrip()"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      page: 1,
      Pagelength: 0,
      dialoge: false,
      editdialogue: false,
      showsnackbar: false,
      msg: null,
      appLoading: false,
      ServerError: false,
      valid: true,
      sectionData: {},
      curItem: {},
      tripList: null,
      mapData: {},
      show2: true,
      searchInput: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phoneRules: [
          (v) => !!v || "phone is required",
          (v) =>
            (v && v.length <= 10) || "number must be less than 11 characters",
          (v) =>
            (v && v.length >= 10) ||
            "number must be greater than 10 characters",
          (v) => /^\d{10}$/.test(v) || "phone number must be a number",
        ],
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      doManual: false,
      addDialog: false,
      busList: [],
      students: [],
      placeList: [],
      division: null,
      cls: null,
      divisionList: null,
      classList: null,
      keyword: "",
    };
  },
  beforeMount() {
    this.getClass();

    if (this.cls) this.getDivision();
    this.getStudents();
    this.getTrips();
  },
  watch: {
    searchInput() {
      console.log("Cl sear", this.searchInput);
      console.log("Stu=", this.mapData.studentId);
      // if (this.searchInput) 
      this.getStudents();
    },
    cls() {
      this.division = null;
      this.searchInput = null;
      this.mapData.studentId = null;
      this.getStudents();
    },
    // division() {
    //   this.searchInput=null
    //   this.mapData.studentId=null
    //   console.log("div cl");
    //   this.getStudents();
    //   console.log("et")
    // },
  },
  methods: {
    getClass() {
      axios({
        method: "get",
        url: "/standard/getlist",

        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.classList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err());
        });
    },
    getDivision() {
      axios({
        method: "get",
        url: "/division/getlist",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          id: this.cls,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.divisionList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err());
        });
    },
    getStudents() {
      if (this.searchInput) {
        for (let i = 0; i < this.searchInput.length; i++) {
          if (this.searchInput[i] == "-") {
            this.keyword = this.searchInput;
            console.log("Got", this.keyword);
            // this.searchInput = null;
            // this.searchAgain();
            return;
          }
        }
        // this.searchInput=name
      }
      this.students = [];
      axios({
        method: "get",
        url: "/bus/students/all/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          keyword: this.searchInput,
          standard: this.cls,
          // division: this.division,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.students = response.data.data;

            this.students.map(
              (item) => (item.title = item.name + "-" + item.admissionNo)
            );

            console.log("dfl=", this.students);
          }
        })
        .catch((err) => {
          console.log(err());
          this.appLoading = false;
        });
    },

    searchAgain() {
      // console.log("dfherer")
      var str = this.keyword.split("-");

      this.keyword = str[0];
      if (this.cls) {
        // var search = this.students.filter((x) => x.name == this.keyword);
        // if (search.length <= 0)
        this.keyword = "";
      }
      this.students = [];
      axios({
        method: "get",
        url: "/bus/students/all/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          keyword: this.keyword,
          standard: this.cls,
          // division: this.division,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.students = response.data.data;

            this.students.map(
              (item) => (item.title = item.name + "-" + item.admissionNo)
            );

            console.log("dfl=", this.students);
          }
        })
        .catch((err) => {
          console.log(err());
          this.appLoading = false;
        });
    },
    getMapped(id) {
      let ar = this.tripList.filter((x) => x._id == id);
      this.getPlaces(ar[0].routeId._id);
    },
    getPlaces(id) {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/bus/admin/trip/view",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.placeList = response.data.Locations;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },

    getTrips() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/bus/trip/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.tripList = response.data.data;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },

    validateInput() {
      if (
        // !this.mapData.name ||
        // !this.mapData.lat ||
        // !this.mapData.lon ||
        !this.mapData.tripId ||
        !this.mapData.studentId ||
        !this.mapData.placeId
      ) {
        this.msg = "All fields are required*";
        this.showsnackbar = true;
        return;
      } else this.mapStudent();
    },
    //add button
    mapStudent() {
      {
        this.appLoading = true;
        axios({
          url: "/bus/map/students",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: this.mapData,
        })
          .then((response) => {
            this.appLoading = false;

            if (response.data.status) {
              this.addDialog = false;
              this.msg = response.data.msg;
              this.showsnackbar = true;
              this.mapData = {};

              this.$refs.form.reset();
              this.$refs.form.resetValidation();
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
#map44 {
  height: 100%;
}
</style>
